import { FactToCheck, ProductConfig } from "../types";

export function determineIsProductConfigIncludeAllFields(factsToCheck: FactToCheck[], config: ProductConfig) {
  return factsToCheck.every(fact => config?.[fact?.factKey]);
}
